// extracted by mini-css-extract-plugin
module.exports = {"reasoncontainer":"styles_reasoncontainer__p1nbl","checkbox":"styles_checkbox__HF87V","reason":"styles_reason__HsIJr"};